import Vue from "vue";
import VueRouter from "vue-router";
import home from "@/views/home/home.vue";
import login from "@/views/login/login.vue";
import userlogin from "@/views/userlogin/userlogin.vue";
import security from "@/views/security/security.vue";
import enterprise_services from "@/views/enterprise_services/enterprise_services.vue";
import extension from "@/views/extension/extension.vue";
import getapi from "@/views/getapi/getapi.vue";
import area from "@/views/area/area.vue";
import area_index from "@/views/area_index/area_index.vue";
import pay from "@/views/pay/pay.vue";
import solution from "@/views/solution/solution.vue";
import soluution from "@/views/soluution/soluution.vue";
import solution_dynamic from "@/views/solution_dynamic/solution_dynamic.vue";
import soluution_static from "@/views/soluution_static/soluution_static.vue";
import updateuser from "@/views/updateuser/updateuser.vue";
import solution_dynamic_data from "@/views/solution_dynamic_data/solution_dynamic_data.vue";
import ucenter from "@/views/ucenter/ucenter.vue";
import zhongjianye from "@/views/zhongjianye/zhongjianye.vue";
import apply_electronic from "@/views/apply_electronic/apply_electronic.vue";
import apply_market from "@/views/apply_market/apply_market.vue";
import apply_advertisement from "@/views/apply_advertisement/apply_advertisement.vue";
import apply_test from "@/views/apply_test/apply_test.vue";
import apply_protect from "@/views/apply_protect/apply_protect.vue";
import apply_opinion from "@/views/apply_opinion/apply_opinion.vue";
import apply_seo from "@/views/apply_seo/apply_seo.vue";
import apply_collection from "@/views/apply_collection/apply_collection.vue";
import apply_media from "@/views/apply_media/apply_media.vue";
import apply_travel from "@/views/apply_travel/apply_travel.vue";
import statement from "@/views/statement/statement.vue";
import law from "@/views/law/law.vue";
import about from "@/views/about/about.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: home,
    meta: { title: "【官网】奇迹ip-海外代理IP 在线国外代理平台" }, // 设置页面标题和 favicon
  },

  {
    path: "/login",
    component: login,
    meta: { title: "登录" },
  },
  {
    path: "/userlogin",
    component: userlogin,
    meta: { title: "注册" },
  },
  {
    path: "/updateuser",
    component: updateuser,
    meta: { title: "修改密码" },
  },
  {
    path: "/security",
    component: security,
    meta: { title: "安全合规" },
  },
  {
    path: "/enterprise_services",
    component: enterprise_services,
    meta: { title: "企业服务" },
  },
  {
    path: "/extension",
    component: extension,
    meta: { title: "推广计划" },
  },
  {
    path: "/getapi",
    component: getapi,
    meta: { title: "API获取" },
  },
  {
    path: "/area",
    component: area,
    meta: { title: "全球热门国家" },
  },
  {
    path: "/area_index",
    component: area_index,
    meta: { title: "国家" },
  },
  {
    path: "/pay",
    component: pay,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/solution",
    component: solution,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/soluution",
    component: soluution,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/solution_dynamic",
    component: solution_dynamic,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/solution_dynamic_data",
    component: solution_dynamic_data,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/soluution_static",
    component: soluution_static,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/ucenter",
    component: ucenter,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/zhongjianye",
    component: zhongjianye,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_electronic",
    component: apply_electronic,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_market",
    component: apply_market,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_advertisement",
    component: apply_advertisement,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_test",
    component: apply_test,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_protect",
    component: apply_protect,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_opinion",
    component: apply_opinion,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_seo",
    component: apply_seo,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_collection",
    component: apply_collection,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_media",
    component: apply_media,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/apply_travel",
    component: apply_travel,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
    {
    path: "/statement",
    component: statement,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/law",
    component: law,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
  {
    path: "/about",
    component: about,
    meta: { title: "HTTPS套餐购买_全球代理" },
  },
];


const router = new VueRouter({
  // 把常量routes放进来 hash history
  mode: "hash",
  routes,
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "【官网】奇迹ip-海外代理IP 在线国外代理平台"; // 设置默认标题
  }

  // 设置页面图标
  const iconLink =
    document.querySelector("link[rel*='icon']") ||
    document.createElement("link");
  iconLink.rel = "icon";
  iconLink.type = "image/png"; // 根据你的图标类型设置
  iconLink.href = to.meta.icon || require("@/assets/logC.png"); // 设置图标路径，使用默认图标

  // 如果没有找到现有的图标链接，则添加新的

    document.head.appendChild(iconLink);


  next();
});

// 全局后置钩子
router.afterEach((to, from) => {
  // 使用 requestAnimationFrame 实现平滑滚动
  const scrollToTop = () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY > 0) {
      window.scrollTo(0, currentScrollY - currentScrollY / 2); // 每次减少 10% 的滚动
      requestAnimationFrame(scrollToTop); // 继续调用
    } else {
      window.scrollTo(0, 0); // 确保最终滚动到顶部
    }
  };
  scrollToTop();
});

// 导出router
export default router;
